module.exports = __webpack_public_path__ + "0c7ab5d6d00cffcf752ac994dd597a16.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_2_b.png
// module id = 41
// module chunks = 0